export const taxes = [
  { satId: '001', name: 'ISR' },
  { satId: '002', name: 'IVA' },
  { satId: '003', name: 'IEPS' }
]

export const cfdiUses = [
  { satId: 'G01', name: 'Adquisición de mercancias' },
  { satId: 'G02', name: 'Devoluciones, descuentos o bonificaciones' },
  { satId: 'G03', name: 'Gastos en general' },
  { satId: 'I01', name: 'Construcciones' },
  { satId: 'I02', name: 'Mobilario y equipo de oficina por inversiones' },
  { satId: 'I03', name: 'Equipo de transporte' },
  { satId: 'I04', name: 'Equipo de computo y accesorios' },
  { satId: 'I05', name: 'Dados, troqueles, moldes, matrices y herramental' },
  { satId: 'I06', name: 'Comunicaciones telefónicas' },
  { satId: 'I07', name: 'Comunicaciones satelitales' },
  { satId: 'I08', name: 'Otra maquinaria y equipo' },
  { satId: 'D01', name: 'Honorarios médicos, dentales y gastos hospitalarios.' },
  { satId: 'D02', name: 'Gastos médicos por incapacidad o discapacidad' },
  { satId: 'D03', name: 'Gastos funerales.' },
  { satId: 'D04', name: 'Donativos.' },
  { satId: 'D05', name: 'Intereses reales efectivamente pagados por créditos hipotecarios (casa habitación).' },
  { satId: 'D06', name: 'Aportaciones voluntarias al SAR.' },
  { satId: 'D07', name: 'Primas por seguros de gastos médicos.' },
  { satId: 'D08', name: 'Gastos de transportación escolar obligatoria.' },
  { satId: 'D09', name: 'Depósitos en cuentas para el ahorro, primas que tengan como base planes de pensiones.' },
  { satId: 'D10', name: 'Pagos por servicios educativos (colegiaturas)' },
  { satId: 'P01', name: 'Por definir' }
]

export const paymentForms = [
  { satId: '01', name: 'Efectivo' },
  { satId: '02', name: 'Cheque nominativo' },
  { satId: '03', name: 'Transferencia electrónica de fondos' },
  { satId: '04', name: 'Tarjeta de crédito' },
  { satId: '05', name: 'Monedero electrónico' },
  { satId: '06', name: 'Dinero electrónico' },
  { satId: '08', name: 'Vales de despensa' },
  { satId: '12', name: 'Dación en pago' },
  { satId: '13', name: 'Pago por subrogación' },
  { satId: '14', name: 'Pago por consignación' },
  { satId: '15', name: 'Condonación' },
  { satId: '17', name: 'Compensación' },
  { satId: '23', name: 'Novación' },
  { satId: '24', name: 'Confusión' },
  { satId: '25', name: 'Remisión de deuda' },
  { satId: '26', name: 'Prescripción o caducidad' },
  { satId: '27', name: 'A satisfacción del acreedor' },
  { satId: '28', name: 'Tarjeta de débito' },
  { satId: '29', name: 'Tarjeta de servicios' },
  { satId: '30', name: 'Aplicación de anticipos' },
  { satId: '31', name: 'Intermediario Pagos' },
  { satId: '99', name: 'Por definir' }
]

export const cfdiTypes = [
  { satId: 'I', name: 'Ingreso' },
  { satId: 'E', name: 'Egreso' },
  { satId: 'T', name: 'Traslado' },
  { satId: 'N', name: 'Nómina' },
  { satId: 'P', name: 'Pago' }
]

export const TAX_REGIMES = [
  { satId: '601', name: 'General de Ley Personas Morales' },
  { satId: '603', name: 'Personas Morales con Fines no Lucrativos' },
  { satId: '605', name: 'Sueldos y Salarios e Ingresos Asimilados a Salarios' },
  { satId: '606', name: 'Arrendamiento' },
  { satId: '608', name: 'Demás ingresos' },
  { satId: '609', name: 'Consolidación' },
  { satId: '610', name: 'Residentes en el Extranjero sin Establecimiento Permanente en México' },
  { satId: '611', name: 'Ingresos por Dividendos (socios y accionistas)' },
  { satId: '612', name: 'Personas Físicas con Actividades Empresariales y Profesionales' },
  { satId: '614', name: 'Ingresos por intereses' },
  { satId: '615', name: 'Régimen de los ingresos por obtención de premios' },
  { satId: '616', name: 'Sin obligaciones fiscales' },
  { satId: '620', name: 'Sociedades Cooperativas de Producción que optan por diferir sus ingresos' },
  { satId: '621', name: 'Incorporación Fiscal' },
  { satId: '622', name: 'Actividades Agrícolas, Ganaderas, Silvícolas y Pesqueras Sí Sí' },
  { satId: '623', name: 'Opcional para Grupos de Sociedades' },
  { satId: '624', name: 'Coordinados' },
  { satId: '628', name: 'Hidrocarburos' },
  { satId: '607', name: 'Régimen de Enajenación o Adquisición de Bienes' },
  { satId: '629', name: 'De los Regímenes Fiscales Preferentes y de las Empresas Multinacionales' },
  { satId: '630', name: 'Enajenación de acciones en bolsa de valores' }
]

export const paymentMethods = [
  { satId: 'PUE', name: 'PUE | Pago en una sola exhibición' },
  { satId: 'PPD', name: 'PPD | Pago en parcialidades o diferido' }
]
